import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getLocal } from '../utils/local'

interface UseAuthProps {
  to?: string
}
function useAuth(data?: UseAuthProps) {
  const navigate = useNavigate()

  const isLoggedIn: boolean = getLocal('isLoggedIn')
  const user = getLocal('user')
  const token: string = getLocal('token')

  React.useEffect(() => {
    if (isLoggedIn && user && token && data?.to) {
      navigate(data?.to!, {
        replace: true,
      })
    }
  }, [data?.to, isLoggedIn, user, token, navigate])
  return {
    isLoggedIn,
    user,
    token,
  }
}

export default useAuth
